import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/catalog";

const fade = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

export default function Faq() {
  return (
    <section id="faq" className="bg-white py-20 lg:py-28" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <motion.div variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="flex items-center gap-4 mb-6">
          <span className="font-mono-med text-sm text-[#D92638] border border-[#D92638]/40 rounded-full px-3.5 py-1">08</span>
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-slate-500">FAQs</span>
          <span className="h-px flex-1 bg-slate-200" />
        </motion.div>
        <motion.h2 variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }}
          className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0B192C] leading-tight">
          Questions, answered honestly.
        </motion.h2>

        <motion.div variants={fade} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} className="mt-10">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}
                className="bg-[#F8FAFC] border border-slate-200/90 rounded-2xl px-6 data-[state=open]:border-[#0D9488]/50 data-[state=open]:bg-[#0D9488]/[0.03] transition-colors">
                <AccordionTrigger className="text-left text-[15px] font-semibold text-[#0B192C] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-600 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
